export default "__VITE_ASSET__BXzfis7u__"